/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.258 2c2.566 0 4.645 2.015 4.645 4.5 0 1.927-1.25 3.57-3.007 4.212 3.45.786 6.027 3.67 6.102 7.133L18 18h-1.032c0-3.586-3.116-6.5-6.968-6.5-3.798 0-6.88 2.833-6.966 6.349L3.032 18H2c0-3.645 2.771-6.678 6.44-7.357C6.778 9.957 5.613 8.36 5.613 6.5c0-2.485 2.08-4.5 4.645-4.5zm0 1C8.263 3 6.645 4.567 6.645 6.5S8.263 10 10.258 10c1.995 0 3.613-1.567 3.613-3.5S12.253 3 10.258 3z" _fill="#1D3861"/>'
  }
})
